import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const ArrowsLeft: FC<IIconsProps> = ({
  color,
  size = IconScale.S,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 16}
      height={size || 16}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25096 9.99807L6.25 9.99903L12.0856 15.8347L13.75 14.1703L9.57782 9.99814L13.7461 5.82988L12.0817 4.16553L6.25007 9.99718L6.25096 9.99807Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowsLeft;
